import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SizesEnum } from '../models/SizesEnum';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Output('triggered') triggered = new EventEmitter<void>();

  @Input() size: SizesEnum;
  @Input() filled: boolean;
  @Input() disabled = false;

  constructor() {}

  ngOnInit() {}

  trigger() {
    this.triggered.emit();
  }
}
